import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { TreeList, Selection, Column } from 'devextreme-react/tree-list';
import Employees from "./components/Employees";
import useOrgStructure from "../../../../hooks/useOrgStructure";
import EditButton from "../../../../../ui/EditButton";
import DepartmentsEditModal from "./components/DepartmentsEditModal";

const styles = () => ({
    root: {
        "& .MuiFormLabel-root": {
            whiteSpace: "nowrap"
        },
        "& .MuiInputBase-input.Mui-disabled": {
            color: "#000"
        }
    },
    treelist : {
      paddingRight: 16,
    },
    top: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    heading: {
        fontSize: 14,
        display: "flex",
        alignItems: "center",
        color: "#000000",
        margin: "8px 0 20px 0"
    },
    block: {},
    checkbox: {
        "& > .MuiCheckbox-colorPrimary.Mui-checked": {
            color: "rgba(0, 127, 189, 0.7);"
        }
    },
    label: {
        fontSize: 12
    },
    avatarContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        '& > span': {
            marginLeft: 10
        }
    },
    link: {
      marginLeft: 16,
      marginTop: 8,
      marginBottom: 20,
      fontSize: 12,
      textDecorationLine: "underline",
      color: "#007FBD",
      cursor: 'pointer',
    }
});

const OrgStructure = ({
    classes,
    info,
}) => {
  const [isDepartmentsModalOpen, setDepartmentsModal] = React.useState(false);
  const [selectedDepartment, setSelectedDepartment] = React.useState(-1);
  const { dataSources, getDepartments, updateDepartments } = useOrgStructure();

  const orgId = (info && info.info && info.info.id) ? info.info.id : -1;

useEffect(() => {
  onLoadData();
}, []);

const onLoadData = () => {
  if (info && info.info && info.info.id > -1) {
    getDepartments(info.info.id);
  }
}

const onSelectionChanged = (e) => {
  const selectedId = (e && e.selectedRowKeys && e.selectedRowKeys.length>0) ? e.selectedRowKeys[0] : -1;
  setSelectedDepartment(selectedId);
}

return (
    <div className={classes.root}>
        <DepartmentsEditModal open={isDepartmentsModalOpen}
          handleClose={() => setDepartmentsModal(false)}
          departmentsList={dataSources.departments}
          getDepartmets={() => onLoadData()}
          onUpdate={updateDepartments}
          orgId={orgId}/>
        <Grid container spacing={1}>
            <Grid item xs={6} sm={6} md={4} lg={3}>
              <div className={classes.treelist}>
                <div className={classes.top}>
                  <Typography className={classes.heading}>Подразделения</Typography>
                  {selectedDepartment > -1 &&
                  <span className={classes.link} onClick={() => setSelectedDepartment(-1)}>Сбросить</span>}
                  <div style={{"marginLeft":16}}>
                    <EditButton onClick={() => setDepartmentsModal(true)}/>
                  </div>
                </div>
              <TreeList
                dataSource={dataSources.departments}
                showColumnHeaders={false}
                showRowLines={true}
                showBorders={true}
                columnAutoWidth={true}
                wordWrapEnabled={true}
                keyExpr="id"
                parentIdExpr="parentId"
                onSelectionChanged={onSelectionChanged}
              >
                <Selection mode="single" />
                <Column dataField="name" caption="Подразделения"/>
              </TreeList>
            </div>
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={9}>
                <Employees depId={selectedDepartment} id={info.info.id} orgName={info.main.name} />
            </Grid>
        </Grid>
    </div>
  );
};

export default withStyles(styles)(OrgStructure);
